import React, { ChangeEvent, Component, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IDashboardItem from "../../../models/IDashboardItem";
import INotification from "../../../models/INotification";
import IOrder_Progress_State from "../../../models/IOrder_Progress_State";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import OrderStatesEnum from "../../../models/OrderStatesEnum";
import OrderEntryService from "../../../services/OrderEntryService";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import "./OrdersAtStepWidget.scss";
import OwTitle from "../../shared/OwTitle/OwTitle";
import UserTypesEnum from "../../../models/UserTypesEnum";
import { Socket } from "socket.io-client";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import IWorkflow from "../../../models/IWorkflow";

type Props = {
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: INotification, isFormatted?: boolean) => void;
    inEditor?: boolean;
    selectedStepDetail?: { step: IOrder_Progress_State; count: number; stepName: string };
    updateStepFn?: (order_step_id: number, widget_uuid: string) => void;
    widget?: IDashboardItem;
    removeWidget?: () => void;
};

export const OrdersAtStepWidget = (props: Props) => {
    const history = useNavigate();
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [selectedStep, setSelectedStep] = React.useState<number | undefined>(props.widget?.widget_data);

    // useEffect(() => {
    //
    // }, [selectedStep]);

    const handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        setSelectedStep(value);

        if (props.updateStepFn && props.widget) {
            props.updateStepFn(Number(value), props.widget.uuid);
        }
    };

    const viewOrdersAtStep = () => {
        const orderStateId = props.selectedStepDetail?.step;

        history(`/orders?order_state=${orderStateId}&filter_shipped=true`);
    };

    if (userModel.supplierUserToken?.User_Type?.id === UserTypesEnum.SHIP_MGMT) {
        return null;
    }

    let workflows = supplierModel.Workflows || [];

    if (!workflows.length) {
        workflows = [{ name: "Default", supplier_id: supplierModel.id, detail: supplierModel.order_progress_states || [] } as IWorkflow];
    }

    // let steps = OrderService.getOrderSteps(this.props.supplierModel, OrderStatesEnum.PRELIMINARY);
    const steps = OrderEntryService.getSortedWorkflowStatus(workflows);

    if (props.inEditor) {
        return (
            <div className={"OrdersAtStepWidget widget"}>
                <div className={""}>
                    <OwIconButton iconClass={"fas fa-trash-alt"} iconColorClass={"text-danger"} fn={props.removeWidget!} />
                </div>

                <div>
                    <OwLabel title={"orders_at_step"} />
                </div>

                <OwSelectOption
                    name={"selected_step"}
                    options={steps}
                    valueProp={"id"}
                    titleProp={"name"}
                    fn={handleChange}
                    selectedOption={selectedStep}
                    hasSelectedOptionProp={false}
                    translateTitle={true}
                />
            </div>
        );
    } else {
        const title = props.selectedStepDetail?.stepName.toLowerCase() || "";

        if (!props.selectedStepDetail) {
            return null;
        }

        if (!title.length) {
            return (
                <div className={"OrdersAtStepWidget widget d-flex flex-column"}>
                    <OwLabel title={"error_no_step_selected"} />
                </div>
            );
        } else {
            return (
                <div className={"OrdersAtStepWidget widget d-flex flex-column"}>
                    {title.length ? <OwTitle tag={"h4"} title={title} /> : null}
                    <div className={"faded-orange number"}>{props.selectedStepDetail?.count}</div>
                    <OwLabel title={"view"} fn={viewOrdersAtStep} />
                </div>
            );
        }
    }
};

export default OrdersAtStepWidget;
